import {createContext} from 'react';

export const MarketSegmentsListContext = createContext({});
